import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-h6 mb-10" }, "Colaboradores permitidos", -1)

import AppTemplate from '@/app/shared/ui/templates/AppTemplate.vue';
import { computed, ref, reactive, inject } from 'vue';
import rules from '@/app/shared/domain/data/rules';
import InputCostCenter from '@/app/shared/components/inputs/InputCostCenter.vue';
import InputClients from '@/app/shared/components/inputs/InputClients.vue';
import InputNumber from '@/app/shared/components/inputs/InputNumber.vue';
import ProjectRepository from '@/app/project/infrastructure/persistence/ProjectRepository';
import Project from '@/app/project/domain/interfaces/Project';
import Tabs from '@/app/shared/components/Tabs.vue';
import { useForm } from '@/app/shared/ui/composable/form';
import InputCollaborators from '@/app/shared/components/inputs/InputCollaborators.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectForm',
  props: ['id'],
  setup(__props) {

const props = __props;


const form = ref(null);
let project = reactive({
    status: 'active',
    billing_auto: false,
    collaborator_ids: [''],
} as Project);

const repository = inject('projectRepository') as ProjectRepository;

const { pageTitle, submit } = useForm(
    props,
    project,
    repository,
    form,
    'Editar projeto',
    'Cadastrar projeto',
    '/projetos',
    '/projetos',
);

const billindDateOptions = computed(() => {
    const options: Array<string> = [];
    for (let i = 1; i <= 30; i++) {
        options.push(i.toString());
    }
    return options;
});

const tabItens = [
    {
        icon: 'mdi:mdi-book-open',
        key: 'main',
        title: 'Principal'
    },
    {
        icon: 'mdi:mdi-lock',
        key: 'permissions',
        title: 'Permissões'
    },
];

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(AppTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "space-around" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { width: "100%" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, { color: "surface" }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _unref(submit),
                    "prepend-icon": "mdi:mdi-content-save",
                    color: "primary",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Salvar")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(pageTitle)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    "lazy-validation": "",
                    ref_key: "form",
                    ref: form
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Tabs, { itens: tabItens }, {
                        main: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputClients, {
                                    rules: [_unref(rules).required],
                                    modelValue: _unref(project).client_id,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(project).client_id) = $event)),
                                    label: "Cliente"
                                  }, null, 8, ["rules", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    rules: [_unref(rules).required],
                                    label: "Nome",
                                    modelValue: _unref(project).name,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(project).name) = $event))
                                  }, null, 8, ["rules", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Nome responsável",
                                    modelValue: _unref(project).responsible_name,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(project).responsible_name) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "E-mail responsável",
                                    rules: [_unref(rules).email],
                                    modelValue: _unref(project).responsible_email,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(project).responsible_email) = $event))
                                  }, null, 8, ["rules", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    label: "Descrição",
                                    rules: [_unref(rules).required],
                                    modelValue: _unref(project).description,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(project).description) = $event))
                                  }, null, 8, ["rules", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_v_text_field, {
                                    label: "Data de inicio",
                                    rules: [_unref(rules).required, _unref(rules).date],
                                    modelValue: _unref(project).initial_date,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(project).initial_date) = $event))
                                  }, null, 8, ["rules", "modelValue"]), [
                                    [_directive_mask, '##/##/####']
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_v_text_field, {
                                    label: "Data final",
                                    rules: [_unref(rules).date],
                                    modelValue: _unref(project).end_date,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(project).end_date) = $event))
                                  }, null, 8, ["rules", "modelValue"]), [
                                    [_directive_mask, '##/##/####']
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputNumber, {
                                    modelValue: _unref(project).total_hours,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(project).total_hours) = $event)),
                                    label: "Total de horas"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select, {
                                    modelValue: _unref(project).status,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(project).status) = $event)),
                                    label: "Status",
                                    items: [
                                    {title: 'Ativo', value: 'active'},
                                    {title: 'Finalizado', value: 'finished'},
                                ]
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select, {
                                    rules: [_unref(rules).required],
                                    modelValue: _unref(project).billing_date,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(project).billing_date) = $event)),
                                    label: "Data de faturamento",
                                    items: _unref(billindDateOptions)
                                  }, null, 8, ["rules", "modelValue", "items"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_switch, {
                                    modelValue: _unref(project).billing_auto,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(project).billing_auto) = $event)),
                                    inset: "",
                                    color: "primary",
                                    label: "Faturamento automático"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputCostCenter, {
                                    modelValue: _unref(project).cost_center_id,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(project).cost_center_id) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        permissions: _withCtx(() => [
                          _hoisted_1,
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputCollaborators, {
                                    rules: [_unref(rules).requiredCombobox],
                                    modelValue: _unref(project).collaborator_ids,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(project).collaborator_ids) = $event))
                                  }, null, 8, ["rules", "modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})